import React from 'react';
import styled from 'styled-components';

const EmptyGroupMemberList: React.FC = () => {
  return <EmptyGroupMemberListComp>No members</EmptyGroupMemberListComp>;
}

export default EmptyGroupMemberList;

const EmptyGroupMemberListComp = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_03_2};
`;
